import AdsError from './AdsError.js'

export class GetRecommendedAdsGenericError extends AdsError {}
